import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [

  {
    path: '/',
    component: Layout,
    name: '职务管理',
    redirect: 'jobGradeManagement',
    hidden: false,
    meta: {
      title: '职务管理',
      icon: 'table',
    },
    children: [
      {
        path: 'jobGradeManagement',
        name: 'JobGradeManagement',
        component: () => import('@/views/setting/jobGradeManagement'),
        meta: { title: '职务管理' }
      },
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/loginNew'),
    hidden: true
  },

  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },
]

export const asyncRouters = [

  {
    path: '/employeeManagement',
    component: Layout,
    name: '人员管理',
    redirect: 'employeeManagement',
    hidden: false,
    meta: {
      title: '人员管理',
      icon: 'user',
    },
    children: [
      {
        path: 'employeeManagement',
        name: 'EmployeeManagement',
        component: () => import('@/views/setting/employeeManagement'),
        meta: { title: '人员管理' }
      },
    ]
  },
  {
    path: '/departmentManagement',
    component: Layout,
    name: '部门管理',
    redirect: 'departmentManagement',
    hidden: false,
    meta: {
      title: '部门管理',
      icon: 'tree',
    },
    children: [
      {
        path: 'departmentManagement',
        name: 'DepartmentManagement',
        component: () => import('@/views/setting/departmentManagement'),
        meta: { title: '部门管理' }
      },
    ]
  },
  {
    path: '/voteManagement',
    component: Layout,
    name: '投票管理',
    redirect: 'voteManagement',
    hidden: false,
    meta: {
      title: '投票管理',
      icon: 'el-icon-s-data',
    },
    children: [

      {
        path: 'promotedManagement',
        name: 'PromotedManagement',
        component: () => import('@/views/setting/promotedManage'),
        meta: { title: '提拔干部管理' }
      },

      {
        path: 'voteManagement',
        name: 'VoteManagement',
        component: () => import('@/views/setting/voteManagement'),
        meta: { title: '投票管理' }
      },

      {
        path: 'voteDetail',
        name: 'VoteDetail',
        component: () => import('@/views/setting/voteManagement/voteDetail'),
        meta: { title: '会议详情' ,activeMenu: '/voteManagement/voteManagement'},
        hidden: true
      },
    ]
  },
  {
    path: '/print',
    component: () => import('@/views/print'),
    name: 'Print',
    meta: {title: '打印'},
    hidden: true
  },

  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }

]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes:constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
